import React from 'react';
import { search, searchPrint } from '../../util/sort';
import './SearchPage.css';
import { useSelector } from 'react-redux';
import { Button, DateFrom, DateTo } from '../../util/bloks';
import { renderImage } from '../../util/imageRenderer';
import Select from 'react-select/base';
import { customStyles, designerOptions } from '../../util/option ';

import { ready } from '../../util/icon';
import { OrderHeader } from '../common/OrderHeader';


const SearchPage = ({ status, printStatus, searchQuery }) => {
  const { manager } = useSelector((state) => state.status);
  
  
  const generalResults = search(manager,searchQuery);
  
  
  return (
    <div className="flex flex-col w-full">
      

       {/* Заголовки */}
       <OrderHeader
          // onFromDateClick={handleFromDate}
          // onToDateClick={handleToDate}
        />
            {generalResults.map(
              (i, key) =>
                !i.end &&(
                  <div
                  className={`flex flex-row h-[70px] w-full mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb]`}
                  key={key}
                >
                   {DateFrom(i.fromDate, i.toDate)}
                  {DateTo(i.toDate)}
                  {renderImage(i.manager)}
                  <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto mt-[15px]"></div>
                    <div className=" w-[7%] flex items-center justify-center">
                      <Select
                        styles={customStyles}
                        options={designerOptions}
                        value={designerOptions.find(
                          (option) => option.value === i.designer
                        )}
                        // onChange={(e) =>
                        //   handleSelectChange(e, i._id, i.designer)
                        // }
                      />
                    </div>
                   
                     {Button(ready)}
                  </div>
                )
            )}
<div className="flex flex-row  w-[97%] my-6 text-center text-[#9E9E9E] text-[1vw] mx-auto ">
              <div className="h-[5px] w-[8%] content-center">DATA</div>
              <div className="h-[5px] w-[8%] content-center">MANAGER</div>
              <div className="h-[5px] w-[8%] content-center">DESIGNER</div>
              <div className="h-[5px] w-[23%] content-center">NAME</div>
              <div className="h-[5px] w-[8%] content-center">SEWING</div>
              <div className="h-[5px] w-[25%] content-center "></div>
              <div className="h-[5px] w-[20%] content-center ">FINISH</div>
            </div>
        
            {/* {printResults.map((i, key) => (
              <React.Fragment key={key}>
                
                <Strip i={i} key={key}/>
              </React.Fragment>
            ))} */}
      </div>
  );
};

export default SearchPage;
